import { render, staticRenderFns } from "./RelationDialog.vue?vue&type=template&id=4cc51f8a&scoped=true"
import script from "./RelationDialog.vue?vue&type=script&lang=js"
export * from "./RelationDialog.vue?vue&type=script&lang=js"
import style0 from "./RelationDialog.vue?vue&type=style&index=0&id=4cc51f8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc51f8a",
  null
  
)

export default component.exports